import Card from "./Card";
import { useTranslation } from "react-i18next";

function Services() {
  const { t } = useTranslation();

  const items = [
    {
      title: t("services.items.web.title"),
      img: "web-img.png",
      text: t("services.items.web.text"),
    },
    {
      title: t("services.items.app.title"),
      img: "app-img.png",
      text: t("services.items.app.text"),
    },
    {
      title: t("services.items.software.title"),
      img: "sft-dev-img.png",
      text: t("services.items.software.text"),
    },
    {
      title: t("services.items.cyber.title"),
      img: "cyb-img.png",
      text: t("services.items.cyber.text"),
    },
    {
      title: t("services.items.domain.title"),
      img: "domain-img.png",
      text: t("services.items.domain.text"),
    },
  ];

  return (
    <section className="container services" id="services">
      <h2 className="main-title text-center">{t("services.title")}</h2>
      <p className="section-lead text-center">{t("services.lead")}</p>
      <div className="services-grid">
        {items.map((item) => (
          <Card key={item.title} title={item.title} img={item.img} text={item.text} />
        ))}
      </div>
    </section>
  );
}

export default Services;
